import { SettingOutlined } from '@ant-design/icons';
import { Button, Checkbox, Dropdown, Tooltip } from 'antd';
import React, { useState } from 'react';

const ChartMetricsSettings = ({
  chartMetrics,
  disabled = false,
  title = 'Chart Metrics Settings',
  visibleMetrics,
  setVisibleMetrics,
}) => {
  const [openMetricsSettings, setOpenMetricsSettings] = useState(false);

  const handleMetricsVisibilityChange = (checkedMetrics) => {
    setVisibleMetrics(checkedMetrics);
  };

  const metricsMenu = (
    <div className="p-3 bg-white shadow-lg rounded-md min-w-[200px]">
      <div className="mb-2 font-medium text-gray-700">Chart Metrics</div>
      <Checkbox.Group
        options={chartMetrics.map((metric) => ({
          label: metric.label,
          value: metric.key,
        }))}
        value={visibleMetrics}
        onChange={handleMetricsVisibilityChange}
        className="flex flex-col gap-2"
      />
    </div>
  );

  return (
    <Tooltip title={title}>
      <Dropdown
        open={openMetricsSettings}
        onOpenChange={setOpenMetricsSettings}
        trigger={['click']}
        dropdownRender={() => metricsMenu}
        arrow
      >
        <Button
          type="text"
          onClick={() => setOpenMetricsSettings(!openMetricsSettings)}
          disabled={disabled}
          icon={<SettingOutlined />}
          className="flex items-center gap-1"
        ></Button>
      </Dropdown>
    </Tooltip>
  );
};

export default ChartMetricsSettings;
